/*
  KAMPANYA GÖSTERİM KATMANI — istemci tarafı.

  Sorun: Shopify'ın "otomatik indirim"i yalnızca sepette/ödemede uygulanır. Ürün
  sayfasında Liquid bunu göremediği için fiyatı kampanya oranıyla biz basıyoruz
  (bkz. snippets/kampanya-fiyat.liquid, snippets/product-block-header.liquid).
  Ancak müşteri BEDEN değiştirdiğinde temanın kendi JS'i (updatePrices) [data-price]
  ve [data-compare-price] içeriğini gerçek Shopify fiyatıyla yeniden yazıyor ve
  kampanyalı gösterim kayboluyor.

  Çözüm: Liquid her varyant için kampanyalı fiyatı HAZIR BİÇİMLENMİŞ olarak
  <script data-kampanya-fiyatlar> içine yazıyor. Bu dosya o değerleri, tema fiyatı
  her ezdiğinde geri koyuyor. Para birimi biçimlendirmesi sunucuda yapıldığı için
  burada hiçbir para hesabı/formatlaması yok — yanlış yuvarlama riski yok.

  Kampanya kapalıysa Liquid script etiketini hiç basmaz, bu dosya da hiçbir şey yapmaz.
*/
(function () {
  'use strict';

  var harita = {};
  var izleniyor = new WeakSet();
  var planlandi = false;

  function haritayiYukle() {
    var kaynaklar = document.querySelectorAll('[data-kampanya-fiyatlar]');
    for (var i = 0; i < kaynaklar.length; i++) {
      try {
        var veri = JSON.parse(kaynaklar[i].textContent);
        for (var vid in veri) {
          if (Object.prototype.hasOwnProperty.call(veri, vid)) harita[vid] = veri[vid];
        }
      } catch (e) {
        /* bozuk JSON: sessizce atla, tema kendi fiyatını göstermeye devam eder */
      }
    }
  }

  // Bir fiyat elemanının hangi varyanta ait olduğunu bul.
  function varyantId(el) {
    var form = el.closest ? el.closest('form[action*="/cart/add"]') : null;
    var input = form ? form.querySelector('[name="id"]') : null;
    if (input && input.value) return input.value;

    // Sticky bar gibi form dışındaki alanlar için sayfadaki ilk ürün formu
    input = document.querySelector('form[action*="/cart/add"] [name="id"]');
    if (input && input.value) return input.value;

    var u = new URLSearchParams(window.location.search).get('variant');
    return u || null;
  }

  function uygula() {
    planlandi = false;

    var fiyatlar = document.querySelectorAll('[data-price]');
    for (var i = 0; i < fiyatlar.length; i++) {
      var el = fiyatlar[i];
      var vid = varyantId(el);
      var kayit = vid ? harita[vid] : null;
      if (!kayit) continue;

      // Tema "Tükendi" / özel içerik gösteriyorsa karışma.
      var kap = el.closest('[data-price-display-type]');
      if (kap && kap.getAttribute('data-price-display-type') !== 'price') continue;

      if (el.innerHTML !== kayit.fiyat) el.innerHTML = kayit.fiyat;
    }

    // Ödenecek fiyatın hemen üstündeki çizili fiyat = mağaza fiyatı.
    // Temanın kendi alanı; satış rengi bu alanın DOLU olmasına bağlı
    // (`s:not(:empty) + [data-price]`), o yüzden burayı hep biz dolduruyoruz.
    var altlar = document.querySelectorAll('[data-compare-price]');
    for (var j = 0; j < altlar.length; j++) {
      var sel = altlar[j];
      var svid = varyantId(sel);
      var skayit = svid ? harita[svid] : null;
      if (!skayit) continue;

      var skap = sel.closest('[data-price-display-type]');
      if (skap && skap.getAttribute('data-price-display-type') !== 'price') continue;

      // Kampanyalı fiyat mağaza fiyatına eşitse üstü çizili göstermeyelim.
      var hedef = skayit.alt === skayit.fiyat ? '' : skayit.alt;
      if (sel.innerHTML !== hedef) sel.innerHTML = hedef;
    }

    // En üstteki çizili fiyat — yalnızca ürünün KENDİ compare_at indirimi varken
    // dolu gelir; yoksa boş bırakılır ve <s> görünmez (CSS: s:empty).
    var ustler = document.querySelectorAll('[data-kampanya-ust]');
    for (var k = 0; k < ustler.length; k++) {
      var ael = ustler[k];
      var avid = varyantId(ael);
      var akayit = avid ? harita[avid] : null;
      if (!akayit) continue;

      var akap = ael.closest('[data-price-display-type]');
      if (akap && akap.getAttribute('data-price-display-type') !== 'price') continue;

      var ahedef = akayit.ust || '';
      if (ael.innerHTML !== ahedef) ael.innerHTML = ahedef;
    }
  }

  function planla() {
    if (planlandi) return;
    planlandi = true;
    window.requestAnimationFrame(uygula);
  }

  // Tema fiyatı her yeniden yazdığında biz de geri yazalım.
  function izle() {
    var hedefler = document.querySelectorAll('[data-price], [data-compare-price], [data-kampanya-ust]');
    for (var i = 0; i < hedefler.length; i++) {
      if (izleniyor.has(hedefler[i])) continue;
      izleniyor.add(hedefler[i]);
      new MutationObserver(planla).observe(hedefler[i], {
        childList: true,
        characterData: true,
        subtree: true
      });
    }
  }

  function baslat() {
    haritayiYukle();
    if (!Object.keys(harita).length) return; // kampanya kapalı
    izle();
    uygula();

    // Hızlı görüntüleme / bölüm yenileme gibi sonradan gelen içerikler için
    new MutationObserver(function () {
      haritayiYukle();
      izle();
      planla();
    }).observe(document.body, { childList: true, subtree: true });

    // Varyant seçimi
    document.addEventListener('change', planla, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', baslat);
  } else {
    baslat();
  }
})();
